<div id="wrapper">
    <div class="site_maintain">
        <img class="img-fluid" src="/assets/img/maintainance.png">
        <h2>Site Under Maintanance!</h2>
    </div>
</div>